import { useMemo, useState } from "react";
import { Input } from "@altimateai/lego";
import { TextFilterMode } from "../types";

interface FilterTextInputProps {
  value: string;
  onChange: (value: { value: string; mode: string } | string) => void;
  placeHolder?: string;
  filterMode?: TextFilterMode;
  selectedOperator: string;
  allowFractional?: boolean;
}

const FilterTextInput = ({
  value,
  onChange,
  placeHolder,
  filterMode,
  selectedOperator,
  allowFractional = false,
}: FilterTextInputProps) => {
  const [inputValue, setInputValue] = useState(value || "");

  const numbersOnly = useMemo(
    () => (allowFractional ? /^[0-9]*\.?[0-9]*$/ : /^[0-9]+$/),
    [allowFractional]
  );

  const handleInputChange = (newValue: string) => {
    if (numbersOnly.test(newValue) || newValue === "") {
      setInputValue(newValue);
    }
  };

  const handleApply = () => {
    if (filterMode) {
      onChange({ value: inputValue, mode: selectedOperator });
    } else {
      onChange(inputValue);
    }
  };

  return (
    <Input
      // currently we support only numbers. if needed we need to extend the filter props
      type="number"
      step={allowFractional ? "any" : "1"}
      value={inputValue}
      onChange={e => handleInputChange(e.target.value)}
      placeholder={placeHolder}
      className="al-w-full"
      onBlur={handleApply}
    />
  );
};

export default FilterTextInput;
